import { request } from '@/shared/api/request'

export const getAllRepresentative = (params) => {
	return request({ url: 'safety/representative/accidents', method: 'GET', params: params, withCredentials: true })
}

export const getRepresentative = (externalId) => {
	return request({ url: 'safety/representative/files?accidentExternalId=' + externalId, method: 'GET' })
}

export const sendRepresentativeXml = (data) => {
	return request({ url: `safety/actN1/represent/xml/${data}`, method: 'POST'})
}

export const sendRepresentative = (data) => {
	return request({ url: `safety/actN1/represent/saveSign`, method: 'POST', data: data })
}
